import React, { ReactNode } from 'react';

interface PageContainerProps {
  children: ReactNode;
  stickyHeader?: ReactNode;
}

const PageContainer: React.FC<PageContainerProps> = ({ children, stickyHeader }) => {
  return (
    <div className="h-full flex flex-col">
      {/* Sticky Header (if provided) */}
      {stickyHeader && (
        <div className="flex-none bg-background">
          {stickyHeader}
        </div>
      )}

      {/* Scrollable Content with bottom padding for mobile nav */}
      <div className="flex-1 overflow-y-auto">
        <div className="space-y-6 px-4 pb-24 md:pb-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageContainer; 